import { useConfigStore } from '~/store/useConfigStore'
import { useIntegrations } from '~/composables/useIntegrations'
import { useCustomFont } from '~/composables/useCustomFont'
import { useDarkTheme } from '~/composables/useDarkTheme'

export const initializeIrWebsite = (options: {
  index: boolean
}) => {
  const config = useConfigStore()

  const link = computed<Array<{ rel: string, type: string, href: string }>>(() => {
    const result = []

    if (config.$state.websiteFavicon) {
      result.push({
        rel: 'icon',
        type: config.$state.websiteFavicon.mimeType,
        href: config.$state.websiteFavicon.src,
      })
    }

    return result
  })

  const meta = [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    {
      name: 'robots',
      content: config.$state.websiteDisableIndex || !options.index ? 'noindex, nofollow' : 'index, follow',
    },
  ]

  if (config.$state.googleSiteVerificationCode) {
    meta.push({
      name: 'google-site-verification',
      content: config.$state.googleSiteVerificationCode,
    })
  }

  useHead({
    titleTemplate: (titleChunk: string | undefined) => {
      return titleChunk ? `${titleChunk} - ${config.$state.websiteTitle}` : config.$state.websiteTitle
    },
    link: link.value,
    meta,
  })

  useSeoMeta({
    ogDescription: (value?: string) => value ?? config.$state.websiteDescription,
    ogTitle: (value?: string) => value ?? config.$state.websiteTitle,
    ogImage: (value?: string) => value ?? config.$state.websiteMetaImage?.src,
    ogSiteName: config.$state.websiteTitle,
    ogLocale: 'en_US',
    ogDeterminer: 'the',
    twitterCard: 'summary_large_image',
  })

  const { initialize } = useGtag()

  onMounted(() => {
    try {
      if (config.$state.googleAnalyticsTag) {
        initialize(config.$state.googleAnalyticsTag)

        useTrackEvent('page_view')
      }
    }
    catch (e: unknown) {
      console.error(e)
    }
  })

  useIntegrations()
  useCustomFont()
  useDarkTheme()
}
